import { useUpdateCompany } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { UpdateCompanyType } from 'src/api/generated/touring/types';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_COMPANY';

type UseUpdateTaxAndDutiesReturnType = {
  updateTaxAndDuties: (data: UpdateCompanyType) => Promise<void>;
};

export const useUpdateTaxAndDuties = (
  companyId: string
): UseUpdateTaxAndDutiesReturnType => {
  const { mutateAsync } = useUpdateCompany();
  const { showSuccess, showError } = useNotification();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateTaxAndDuties = async (data: UpdateCompanyType): Promise<void> => {
    await mutateAsync(
      {
        companyId,
        data: {
          vatRate: data.vatRate,
          isKskLiable: data.isKskLiable,
        },
      },
      { onSuccess, onError }
    );
  };

  return { updateTaxAndDuties };
};
